// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Core__Int from "@rescript/core/src/Core__Int.bs.js";
import * as Stdlib_Exn from "@rescript/runtime/lib/es6/Stdlib_Exn.js";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Icon$OrcaPaymentPage from "./Icon.bs.js";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";
import * as Utils$OrcaPaymentPage from "./Utilities/Utils.bs.js";
import * as CardPattern$OrcaPaymentPage from "../shared-code/sdk-utils/validation/CardPattern.bs.js";
import * as PaymentType$OrcaPaymentPage from "./Types/PaymentType.bs.js";
import * as CardThemeType$OrcaPaymentPage from "./Types/CardThemeType.bs.js";
import * as CardValidations$OrcaPaymentPage from "../shared-code/sdk-utils/validation/CardValidations.bs.js";

function useDefaultCardProps() {
  let cardRef = React.useRef(null);
  return {
    isCardValid: undefined,
    setIsCardValid: param => {},
    isCardSupported: undefined,
    updateCardSupport: param => {},
    cardNumber: "",
    changeCardNumber: param => {},
    handleCardBlur: param => {},
    cardRef: cardRef,
    icon: null,
    cardError: "",
    setCardError: param => {},
    maxCardLength: 0,
    cardBrand: "",
    cardEligibilityError: undefined,
    updateCardEligibilityError: param => {},
    eligibilitySurchargeDetails: undefined,
    isEligibilityPending: false
  };
}

function useDefaultExpiryProps() {
  let expiryRef = React.useRef(null);
  return {
    isExpiryValid: undefined,
    setIsExpiryValid: param => {},
    cardExpiry: "",
    changeCardExpiry: param => {},
    handleExpiryBlur: param => {},
    expiryRef: expiryRef,
    onExpiryKeyDown: param => {},
    expiryError: "",
    setExpiryError: param => {}
  };
}

function useDefaultCvcProps() {
  let cvcRef = React.useRef(null);
  return {
    isCVCValid: undefined,
    setIsCVCValid: param => {},
    cvcNumber: "",
    setCvcNumber: param => {},
    changeCVCNumber: param => {},
    handleCVCBlur: param => {},
    cvcRef: cvcRef,
    onCvcKeyDown: param => {},
    cvcError: "",
    setCvcError: param => {},
    maxCVCLength: CardValidations$OrcaPaymentPage.getobjFromCardPattern("").maxCVCLength
  };
}

function useDefaultZipProps() {
  let zipRef = React.useRef(null);
  return {
    isZipValid: undefined,
    setIsZipValid: param => {},
    zipCode: "",
    changeZipCode: param => {},
    handleZipBlur: param => {},
    zipRef: zipRef,
    onZipCodeKeyDown: param => {},
    displayPincode: false
  };
}

function toString(val) {
  return val.toString();
}

function getQueryParamsDictforKey(searchParams, keyName) {
  let dict = {};
  searchParams.split("&").forEach(paramStr => {
    let eqIndex = paramStr.indexOf("=");
    if (eqIndex === -1) {
      return;
    }
    let len = paramStr.length;
    let key = paramStr.slice(0, eqIndex);
    let value = paramStr.slice(eqIndex + 1 | 0, len);
    dict[key] = value;
  });
  return Core__Option.getOr(dict[keyName], "");
}

function getCardType(val) {
  switch (val) {
    case "AmericanExpress" :
      return "AMEX";
    case "BAJAJ" :
      return "BAJAJ";
    case "CartesBancaires" :
      return "CARTESBANCAIRES";
    case "DinersClub" :
      return "DINERSCLUB";
    case "Discover" :
      return "DISCOVER";
    case "Interac" :
      return "INTERAC";
    case "JCB" :
      return "JCB";
    case "Maestro" :
      return "MAESTRO";
    case "Mastercard" :
      return "MASTERCARD";
    case "RuPay" :
      return "RUPAY";
    case "SODEXO" :
      return "SODEXO";
    case "UnionPay" :
      return "UNIONPAY";
    case "Visa" :
      return "VISA";
    default:
      return "NOTFOUND";
  }
}

function getCardStringFromType(val) {
  switch (val) {
    case "VISA" :
      return "Visa";
    case "MASTERCARD" :
      return "Mastercard";
    case "AMEX" :
      return "AmericanExpress";
    case "MAESTRO" :
      return "Maestro";
    case "DINERSCLUB" :
      return "DinersClub";
    case "DISCOVER" :
      return "Discover";
    case "BAJAJ" :
      return "BAJAJ";
    case "SODEXO" :
      return "SODEXO";
    case "RUPAY" :
      return "RuPay";
    case "JCB" :
      return "JCB";
    case "CARTESBANCAIRES" :
      return "CartesBancaires";
    case "UNIONPAY" :
      return "UnionPay";
    case "INTERAC" :
      return "Interac";
    case "NOTFOUND" :
      return "NOTFOUND";
  }
}

function normalizeCardBrand(brand) {
  let normalized = brand.toLowerCase().replace(/[_\\s-]/g, "");
  switch (normalized) {
    case "americanexpress" :
    case "amex" :
      return "AmericanExpress";
    case "bajaj" :
      return "BAJAJ";
    case "cartesbancaires" :
      return "CartesBancaires";
    case "diners" :
    case "dinersclub" :
      return "DinersClub";
    case "discover" :
      return "Discover";
    case "interac" :
      return "Interac";
    case "jcb" :
      return "JCB";
    case "maestro" :
      return "Maestro";
    case "mastercard" :
      return "Mastercard";
    case "rupay" :
      return "RuPay";
    case "sodexo" :
      return "SODEXO";
    case "unionpay" :
      return "UnionPay";
    case "visa" :
      return "Visa";
    default:
      return brand;
  }
}

function getCardBrandDisplayName(cardBrand) {
  let cardBrandString = getCardStringFromType(cardBrand);
  if (cardBrandString === "NOTFOUND") {
    return "Unknown";
  } else {
    return cardBrandString;
  }
}

function getCurrentMonthAndYear(dateTimeIsoString) {
  let tempTimeDateString = dateTimeIsoString.replace("Z", "");
  let tempTimeDate = tempTimeDateString.split("T");
  let date = Core__Option.getOr(tempTimeDate[0], "");
  let dateComponents = date.split("-");
  let currentMonth = Core__Option.getOr(dateComponents[1], "");
  let currentYear = Core__Option.getOr(dateComponents[0], "");
  return [
    CardValidations$OrcaPaymentPage.toInt(currentMonth),
    CardValidations$OrcaPaymentPage.toInt(currentYear)
  ];
}

function formatCardNumber(val, cardType) {
  let clearValue = CardValidations$OrcaPaymentPage.clearSpaces(val);
  let tmp;
  let exit = 0;
  switch (cardType) {
    case "AMEX" :
      tmp = clearValue.slice(0, 4) + ` ` + clearValue.slice(4, 10) + ` ` + clearValue.slice(10, 15);
      break;
    case "MAESTRO" :
    case "BAJAJ" :
    case "JCB" :
    case "CARTESBANCAIRES" :
    case "INTERAC" :
    case "NOTFOUND" :
      exit = 1;
      break;
    default:
      tmp = clearValue.slice(0, 4) + ` ` + clearValue.slice(4, 8) + ` ` + clearValue.slice(8, 12) + ` ` + clearValue.slice(12, 16) + ` ` + clearValue.slice(16, 19);
  }
  if (exit === 1) {
    tmp = clearValue.slice(0, 4) + ` ` + clearValue.slice(4, 8) + ` ` + clearValue.slice(8, 12) + ` ` + clearValue.slice(12, 16) + ` ` + clearValue.slice(16, 19);
  }
  return tmp.trim();
}

function getExpiryYearPrefix() {
  let date = new Date().toISOString();
  let match = getCurrentMonthAndYear(date);
  return match[1].toString().slice(0, 2);
}

function getExpiryDates(val) {
  let match = CardValidations$OrcaPaymentPage.splitExpiryDates(val);
  let prefix = getExpiryYearPrefix();
  return [
    match[0],
    prefix + match[1]
  ];
}

function formatExpiryToTwoDigit(expiry) {
  if (expiry.length === 2) {
    return expiry;
  } else {
    return expiry.slice(2, 4);
  }
}

function isExpiryComplete(val) {
  let match = CardValidations$OrcaPaymentPage.splitExpiryDates(val);
  if (match[0].length === 2) {
    return match[1].length === 2;
  } else {
    return false;
  }
}

function getCardBrand(cardNumber) {
  try {
    let card = cardNumber.replace(/[^\d]/g, "");
    let rupayRanges = [
      [
        508227,
        508227
      ],
      [
        508500,
        508999
      ],
      [
        603741,
        603741
      ],
      [
        606985,
        607384
      ],
      [
        607385,
        607484
      ],
      [
        607485,
        607984
      ],
      [
        608001,
        608100
      ],
      [
        608101,
        608200
      ],
      [
        608201,
        608300
      ],
      [
        608301,
        608350
      ],
      [
        608351,
        608500
      ],
      [
        652150,
        652849
      ],
      [
        652850,
        653049
      ],
      [
        653050,
        653149
      ],
      [
        817290,
        817290
      ]
    ];
    let masterCardRanges = [
      [
        222100,
        272099
      ],
      [
        510000,
        559999
      ]
    ];
    let doesFallInRange = (cardRanges, isin) => {
      let intIsin = Core__Option.getOr(Core__Int.fromString(isin.replace(/[^\d]/g, "").substring(0, 6), undefined), 0);
      let range = cardRanges.map(cardRange => {
        if (intIsin >= cardRange[0]) {
          return intIsin <= cardRange[1];
        } else {
          return false;
        }
      });
      return range.includes(true);
    };
    if (doesFallInRange(rupayRanges, card)) {
      return "RuPay";
    } else if (doesFallInRange(masterCardRanges, card)) {
      return "Mastercard";
    } else {
      return Core__Option.getOr(CardPattern$OrcaPaymentPage.cardPatterns.map(item => {
          if (Core__Option.isSome(Primitive_option.fromNullable(card.match(item.pattern)))) {
            return item.issuer;
          } else {
            return "";
          }
        }).filter(item => item !== "")[0], "");
    }
  } catch (_error) {
    return "";
  }
}

function calculateLuhn(value) {
  let card = CardValidations$OrcaPaymentPage.clearSpaces(value);
  let splitArr = card.split("");
  splitArr.reverse();
  let unCheckArr = splitArr.filter((param, i) => i % 2 === 0);
  let checkArr = splitArr.filter((param, i) => (i + 1 | 0) % 2 === 0).map(item => {
    let val = CardValidations$OrcaPaymentPage.toInt(item);
    let double = (val << 1);
    let str = double.toString();
    let arr = str.split("");
    let match = arr[0];
    let match$1 = arr[1];
    if (match !== undefined && match$1 !== undefined && double > 9) {
      return (CardValidations$OrcaPaymentPage.toInt(match) + CardValidations$OrcaPaymentPage.toInt(match$1) | 0).toString();
    } else {
      return str;
    }
  });
  let sumofCheckArr = Core__Array.reduce(checkArr, 0, (acc, val) => acc + CardValidations$OrcaPaymentPage.toInt(val) | 0);
  let sumofUnCheckedArr = Core__Array.reduce(unCheckArr, 0, (acc, val) => acc + CardValidations$OrcaPaymentPage.toInt(val) | 0);
  let totalSum = sumofCheckArr + sumofUnCheckedArr | 0;
  if (totalSum % 10 === 0) {
    return true;
  } else {
    return [
      "3000100811111072",
      "4000100511112003"
    ].includes(card);
  }
}

function getCardBrandIcon(cardType, paymentType) {
  switch (cardType) {
    case "VISA" :
      return JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
        name: "visa-light",
        size: Utils$OrcaPaymentPage.brandIconSize
      });
    case "MASTERCARD" :
      return JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
        name: "mastercard",
        size: Utils$OrcaPaymentPage.brandIconSize
      });
    case "AMEX" :
      return JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
        name: "amex-light",
        size: Utils$OrcaPaymentPage.brandIconSize
      });
    case "MAESTRO" :
      return JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
        name: "maestro",
        size: Utils$OrcaPaymentPage.brandIconSize
      });
    case "DINERSCLUB" :
      return JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
        name: "diners",
        size: Utils$OrcaPaymentPage.brandIconSize
      });
    case "DISCOVER" :
      return JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
        name: "discover",
        size: Utils$OrcaPaymentPage.brandIconSize
      });
    case "BAJAJ" :
    case "SODEXO" :
      return JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
        name: "card",
        size: Utils$OrcaPaymentPage.brandIconSize
      });
    case "RUPAY" :
      return JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
        name: "rupay-card",
        size: Utils$OrcaPaymentPage.brandIconSize
      });
    case "JCB" :
      return JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
        name: "jcb-card",
        size: Utils$OrcaPaymentPage.brandIconSize
      });
    case "CARTESBANCAIRES" :
      return JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
        name: "cartesbancaires-card",
        size: Utils$OrcaPaymentPage.brandIconSize
      });
    case "UNIONPAY" :
      return JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
        name: "union-pay",
        size: Utils$OrcaPaymentPage.brandIconSize
      });
    case "INTERAC" :
      return JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
        name: "interac",
        size: Utils$OrcaPaymentPage.brandIconSize
      });
    case "NOTFOUND" :
      if (paymentType === "Payment") {
        return JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
          name: "base-card",
          size: Utils$OrcaPaymentPage.brandIconSize
        });
      } else {
        return JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
          name: "default-card",
          size: Utils$OrcaPaymentPage.brandIconSize
        });
      }
  }
}

function getExpiryValidity(cardExpiry) {
  let date = new Date().toISOString();
  let match = getExpiryDates(cardExpiry);
  let year = match[1];
  let month = match[0];
  let match$1 = getCurrentMonthAndYear(date);
  let currentYear = match$1[1];
  if (currentYear === CardValidations$OrcaPaymentPage.toInt(year) && CardValidations$OrcaPaymentPage.toInt(month) >= match$1[0] && CardValidations$OrcaPaymentPage.toInt(month) <= 12) {
    return true;
  } else if (CardValidations$OrcaPaymentPage.toInt(year) > currentYear && CardValidations$OrcaPaymentPage.toInt(year) < (new Date(Date.now()).getFullYear() + 100 | 0) && CardValidations$OrcaPaymentPage.toInt(month) >= 1) {
    return CardValidations$OrcaPaymentPage.toInt(month) <= 12;
  } else {
    return false;
  }
}

function isExipryValid(val) {
  if (val.length > 0 && getExpiryValidity(val)) {
    return isExpiryComplete(val);
  } else {
    return false;
  }
}

function cardNumberInRange(val, cardBrand) {
  let clearValue = CardValidations$OrcaPaymentPage.clearSpaces(val);
  let obj = CardValidations$OrcaPaymentPage.getobjFromCardPattern(cardBrand);
  return obj.length.map(item => clearValue.length === item);
}

function max(a, b) {
  return Math.max(a, b);
}

function getMaxLength(val) {
  let obj = CardValidations$OrcaPaymentPage.getobjFromCardPattern(val);
  let maxValue = Core__Array.reduce(obj.length, 0, max);
  if (maxValue <= 12) {
    return maxValue + 2 | 0;
  } else if (maxValue <= 16) {
    return maxValue + 3 | 0;
  } else if (maxValue <= 19) {
    return maxValue + 4 | 0;
  } else {
    return maxValue + 2 | 0;
  }
}

function cvcNumberInRange(val, cardBrand) {
  let clearValue = CardValidations$OrcaPaymentPage.clearSpaces(val);
  let obj = CardValidations$OrcaPaymentPage.getobjFromCardPattern(cardBrand);
  return obj.cvcLength.map(item => clearValue.length === item);
}

function generateFontsLink(fonts) {
  if (fonts.length > 0) {
    fonts.map(item => {
      if (item.cssSrc !== "") {
        let link = document.createElement("link");
        link.href = item.cssSrc;
        link.rel = "stylesheet";
        return document.body.appendChild(link);
      }
      if (item.family === "" || item.src === "") {
        return;
      }
      let newStyle = document.createElement("style");
      newStyle.appendChild(document.createTextNode(`\
@font-face {\
    font-family: "` + item.family + `";\
    src: url(` + item.src + `);\
    font-weight: "` + item.weight + `";\
}\
`));
      document.body.appendChild(newStyle);
    });
    return;
  }
}

function maxCardLength(cardBrand) {
  let obj = CardValidations$OrcaPaymentPage.getobjFromCardPattern(cardBrand);
  return Core__Array.reduce(obj.length, 0, (acc, val) => Math.max(acc, val));
}

function isCardLengthValid(cardBrand, cardNumberLength) {
  let obj = CardValidations$OrcaPaymentPage.getobjFromCardPattern(cardBrand);
  return obj.length.includes(cardNumberLength);
}

function cardValid(cardNumber, cardBrand) {
  let clearValueLength = CardValidations$OrcaPaymentPage.clearSpaces(cardNumber).length;
  if (isCardLengthValid(cardBrand, clearValueLength)) {
    return calculateLuhn(cardNumber);
  } else {
    return false;
  }
}

function focusCardValid(cardNumber, cardBrand) {
  let clearValueLength = CardValidations$OrcaPaymentPage.clearSpaces(cardNumber).length;
  if (cardBrand === "") {
    if (clearValueLength === maxCardLength(cardBrand)) {
      return calculateLuhn(cardNumber);
    } else {
      return false;
    }
  } else if (clearValueLength === maxCardLength(cardBrand) || cardBrand === "Visa" && clearValueLength === 16) {
    return calculateLuhn(cardNumber);
  } else {
    return false;
  }
}

function blurRef(ref) {
  Core__Option.forEach(Primitive_option.fromNullable(ref.current), input => {
    input.blur();
  });
}

function focusRef(ref) {
  Core__Option.forEach(Primitive_option.fromNullable(ref.current), input => {
    input.focus();
  });
}

function handleInputFocus(currentRef, destinationRef) {
  let optionalRef = destinationRef.current;
  if (optionalRef == null) {
    return blurRef(currentRef);
  } else {
    Core__Option.forEach((optionalRef == null) ? undefined : Primitive_option.some(optionalRef), input => {
      input.focus();
    });
    return;
  }
}

function getCardElementValue(iframeId, key) {
  let frames = parent.frames;
  let framesCount = frames.length;
  let _index = 0;
  while (true) {
    let index = _index;
    if (index >= framesCount) {
      return "";
    }
    let probed;
    try {
      let frame = frames[index];
      if (frame.name !== iframeId) {
        let dom = frame.document.getElementById(key);
        probed = (dom == null) ? "" : dom.value;
      } else {
        probed = "";
      }
    } catch (raw_exn) {
      let exn = Primitive_exceptions.internalToException(raw_exn);
      let exit = 0;
      if (!(exn.RE_EXN_ID === Stdlib_Exn.$$Error && Primitive_object.equal(exn._1.name, "SecurityError"))) {
        exit = 1;
      }
      if (exit === 1) {
        console.warn(`Skipped frame ` + index.toString() + ` while reading ` + key, exn);
      }
      probed = "";
    }
    if (probed !== "") {
      return probed;
    }
    _index = index + 1 | 0;
    continue;
  };
}

function checkCardCVC(cvcNumber, cardBrand) {
  if (cvcNumber.length > 0) {
    return cvcNumberInRange(cvcNumber, cardBrand).includes(true);
  } else {
    return false;
  }
}

function checkCardExpiry(expiry) {
  if (expiry.length > 0) {
    return getExpiryValidity(expiry);
  } else {
    return false;
  }
}

function getBoolOptionVal(boolOptionVal) {
  if (boolOptionVal !== undefined) {
    if (boolOptionVal) {
      return "valid";
    } else {
      return "invalid";
    }
  } else {
    return "";
  }
}

function commonKeyDownEvent(ev, srcRef, destRef, srcEle, destEle, setEle) {
  let key = ev.keyCode;
  if (key === 8 && srcEle === "") {
    handleInputFocus(srcRef, destRef);
    setEle(param => destEle.slice(0, -1));
    ev.preventDefault();
    return;
  }
}

function pincodeVisibility(brand) {
  return Core__Option.getOr(CardPattern$OrcaPaymentPage.cardPatterns.filter(obj => obj.issuer === brand)[0], CardPattern$OrcaPaymentPage.defaultCardPattern).pincodeRequired;
}

function swapCardOption(cardOpts, dropOpts, selectedOption) {
  let popEle = cardOpts.pop();
  dropOpts.push(Core__Option.getOr(popEle, ""));
  cardOpts.push(selectedOption);
  let temp = dropOpts.filter(item => item !== selectedOption);
  return [
    cardOpts,
    temp
  ];
}

function setCardValid(cardnumber, cardBrand, setIsCardValid) {
  let isCardMaxLength = cardnumber.length === maxCardLength(cardBrand);
  if (cardValid(cardnumber, cardBrand)) {
    return setIsCardValid(param => true);
  } else if (!cardValid(cardnumber, cardBrand) && isCardMaxLength) {
    return setIsCardValid(param => false);
  } else if (!isCardMaxLength) {
    return setIsCardValid(param => {});
  } else {
    return;
  }
}

function setExpiryValid(expiry, setIsExpiryValid) {
  if (isExipryValid(expiry)) {
    return setIsExpiryValid(param => true);
  } else if (!getExpiryValidity(expiry) && isExpiryComplete(expiry)) {
    return setIsExpiryValid(param => false);
  } else if (!isExpiryComplete(expiry)) {
    return setIsExpiryValid(param => {});
  } else {
    return;
  }
}

function getLayoutClass(layout) {
  if (layout.TAG === "StringLayout") {
    return {
      defaultCollapsed: PaymentType$OrcaPaymentPage.defaultLayout.defaultCollapsed,
      radios: PaymentType$OrcaPaymentPage.defaultLayout.radios,
      spacedAccordionItems: PaymentType$OrcaPaymentPage.defaultLayout.spacedAccordionItems,
      maxAccordionItems: PaymentType$OrcaPaymentPage.defaultLayout.maxAccordionItems,
      type: layout._0,
      savedMethodCustomization: PaymentType$OrcaPaymentPage.defaultLayout.savedMethodCustomization,
      paymentMethodsArrangementForTabs: PaymentType$OrcaPaymentPage.defaultLayout.paymentMethodsArrangementForTabs,
      displayOneClickPaymentMethodsOnTop: PaymentType$OrcaPaymentPage.defaultLayout.displayOneClickPaymentMethodsOnTop,
      showCheckedIconForSelection: PaymentType$OrcaPaymentPage.defaultLayout.showCheckedIconForSelection,
      separatorText: PaymentType$OrcaPaymentPage.defaultLayout.separatorText,
      cvcIcon: PaymentType$OrcaPaymentPage.defaultLayout.cvcIcon,
      cardBrandIcon: PaymentType$OrcaPaymentPage.defaultLayout.cardBrandIcon
    };
  } else {
    return layout._0;
  }
}

function getCardBrandIconVisibility(cardBrandIconSetting, cardType) {
  switch (cardBrandIconSetting) {
    case "Hidden" :
      return false;
    case "Standard" :
    case "Animated" :
      return true;
    case "HideGeneric" :
      return cardType !== "NOTFOUND";
  }
}

function getAllBanknames(obj) {
  return Core__Array.reduce(obj, [], (acc, item) => {
    item.map(val => {
      acc.push(val);
    });
    return acc;
  });
}

let clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

function postalRegex(postalCodes, country) {
  let clientCountry = Utils$OrcaPaymentPage.getClientCountry(clientTimeZone);
  let country$1 = Core__Option.getOr(country, clientCountry.isoAlpha2);
  return Utils$OrcaPaymentPage.getCountryPostal(country$1, postalCodes).regex;
}

function setRightIconForCvc(cardEmpty, cardInvalid, color, cardComplete, cvcIconOpt) {
  let cvcIcon = cvcIconOpt !== undefined ? cvcIconOpt : "Default";
  if (cvcIcon === "Hidden") {
    return null;
  } else if (cardEmpty) {
    return JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
      name: "cvc-empty",
      size: Utils$OrcaPaymentPage.brandIconSize
    });
  } else if (cardInvalid) {
    return JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
        name: "cvc-invalid",
        size: Utils$OrcaPaymentPage.brandIconSize
      }),
      style: {
        color: color
      }
    });
  } else if (cardComplete) {
    return JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
      name: "cvc-complete",
      size: Utils$OrcaPaymentPage.brandIconSize
    });
  } else {
    return JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
      name: "cvc-empty",
      size: Utils$OrcaPaymentPage.brandIconSize
    });
  }
}

function useCardDetails(cvcNumber, isCvcValidValue, isCVCValid) {
  return React.useMemo(() => {
    let isCardDetailsEmpty = cvcNumber.length === 0;
    let isCardDetailsValid = isCvcValidValue === "valid";
    let isCardDetailsInvalid = isCvcValidValue === "invalid";
    return [
      isCardDetailsEmpty,
      isCardDetailsValid,
      isCardDetailsInvalid
    ];
  }, [
    cvcNumber,
    isCvcValidValue,
    isCVCValid
  ]);
}

function getWalletBrandIcon(customerMethod) {
  let match = customerMethod.paymentMethodType;
  let iconName;
  if (match !== undefined) {
    switch (match) {
      case "apple_pay" :
        iconName = "apple_pay_saved";
        break;
      case "google_pay" :
        iconName = "google_pay_saved";
        break;
      case "paypal" :
        iconName = "paypal";
        break;
      case "samsung_pay" :
        iconName = "samsung_pay_saved";
        break;
      default:
        iconName = "default-card";
    }
  } else {
    iconName = "default-card";
  }
  return JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
    name: iconName,
    size: Utils$OrcaPaymentPage.brandIconSize
  });
}

function getPaymentMethodBrand(customerMethod) {
  let match = customerMethod.paymentMethod;
  if (match === "wallet") {
    return getWalletBrandIcon(customerMethod);
  }
  let ele = customerMethod.card.scheme;
  return getCardBrandIcon(getCardType(ele !== undefined ? ele : ""), CardThemeType$OrcaPaymentPage.getPaymentMode(""));
}

function getFirstValidCardSchemeFromPML(cardNumber, enabledCardSchemes) {
  let allMatchedCards = CardValidations$OrcaPaymentPage.getAllMatchedCardSchemes(CardValidations$OrcaPaymentPage.clearSpaces(cardNumber));
  return allMatchedCards.find(card => CardValidations$OrcaPaymentPage.isCardSchemeEnabled(card.toLowerCase(), enabledCardSchemes));
}

function getEligibleCoBadgedCardSchemes(matchedCardSchemes, enabledCardSchemes) {
  return matchedCardSchemes.filter(ele => enabledCardSchemes.includes(ele.toLowerCase()));
}

function getCardBrandFromStates(cardBrand, cardScheme, showPaymentMethodsScreen) {
  if (showPaymentMethodsScreen) {
    return cardBrand;
  } else {
    return cardScheme;
  }
}

function getCardBrandInvalidError(cardBrand, localeString) {
  if (cardBrand === "") {
    return localeString.enterValidCardNumberErrorText;
  } else {
    return localeString.cardBrandConfiguredErrorText(cardBrand);
  }
}

function emitExpiryDate(targetOriginOpt, formattedExpiry) {
  let targetOrigin = targetOriginOpt !== undefined ? targetOriginOpt : "*";
  Utils$OrcaPaymentPage.messageParentWindow(targetOrigin, [[
      "expiryDate",
      formattedExpiry
    ]]);
}

function emitIsFormReadyForSubmission(isFormReadyForSubmission) {
  Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
      "isFormReadyForSubmission",
      isFormReadyForSubmission
    ]]);
}

function getCardBin(cardNumber) {
  return CardValidations$OrcaPaymentPage.clearSpaces(cardNumber).substring(0, 6);
}

function getCardLast4(cardNumber) {
  let clearValue = CardValidations$OrcaPaymentPage.clearSpaces(cardNumber);
  let len = clearValue.length;
  if (len >= 4) {
    return clearValue.slice(len - 4 | 0);
  } else {
    return clearValue;
  }
}

export {
  useDefaultCardProps,
  useDefaultExpiryProps,
  useDefaultCvcProps,
  useDefaultZipProps,
  toString,
  getQueryParamsDictforKey,
  getCardType,
  getCardStringFromType,
  normalizeCardBrand,
  getCardBrandDisplayName,
  getCurrentMonthAndYear,
  formatCardNumber,
  getExpiryYearPrefix,
  getExpiryDates,
  formatExpiryToTwoDigit,
  isExpiryComplete,
  getCardBrand,
  calculateLuhn,
  getCardBrandIcon,
  getExpiryValidity,
  isExipryValid,
  cardNumberInRange,
  max,
  getMaxLength,
  cvcNumberInRange,
  generateFontsLink,
  maxCardLength,
  isCardLengthValid,
  cardValid,
  focusCardValid,
  blurRef,
  focusRef,
  handleInputFocus,
  getCardElementValue,
  checkCardCVC,
  checkCardExpiry,
  getBoolOptionVal,
  commonKeyDownEvent,
  pincodeVisibility,
  swapCardOption,
  setCardValid,
  setExpiryValid,
  getLayoutClass,
  getCardBrandIconVisibility,
  getAllBanknames,
  clientTimeZone,
  postalRegex,
  setRightIconForCvc,
  useCardDetails,
  getWalletBrandIcon,
  getPaymentMethodBrand,
  getFirstValidCardSchemeFromPML,
  getEligibleCoBadgedCardSchemes,
  getCardBrandFromStates,
  getCardBrandInvalidError,
  emitExpiryDate,
  emitIsFormReadyForSubmission,
  getCardBin,
  getCardLast4,
}
/* clientTimeZone Not a pure module */
